export default {
    changeCreditLimitDecreaseContent: {
        dataTrackId: 'change-credit-limit-decrease-content',
        dataTrackLinkname: 'endre kredittgrense senk grensen informasjon',
    },
    changeCreditLimitAdjustmentDecrease: {
        dataTrackId: 'change-credit-limi-adjustment-decrease',
        dataTrackLinkname: 'endre kredittgrense tool trykk senk grensen',
    },
    changeCreditLimitAdjustmentIncrease: {
        dataTrackId: 'change-credit-limi-adjustment-increase',
        dataTrackLinkname: 'endre kredittgrense tool trykk ok grensen',
    },
    changeCreditLimitClickDecrease: {
        dataTrackId: 'change-credit-limit-click',
        dataTrackLinkname: 'senk grensen',
    },
    changeCreditLimitClickIncrease: {
        dataTrackId: 'change-credit-limit-click',
        dataTrackLinkname: 'ok grensen',
    },
    changeCreditLimitNotActiveMessage: {
        dataTrackId: 'change-credit-limit-not-active-message',
        dataTrackLinkname: 'endre kredittgrense ikke aktiv',
    },
    changeCreditLimitForm: {
        dataTrackId: 'change-credit-limit-form',
        dataTrackLinkname: 'endre kredittgrense skjema',
    },
};
